import { METHOD, STORAGE_KEY } from '../utils/Constant';
import { URL } from '../utils/Config';
import {
  getApiClient,
  getAuthHeaders,
  getFullAuthHeaders,
  getMultipartAuthHeaders,
  getPowerBIFullAuthHeaders,
} from './base';
import { initializeFaro } from '../otel/otel.config';
import { getFromLocalStorage } from '../utils/Util';

const faro = initializeFaro();

export const candidateDetails = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.CANDIDATE_COMPLETE_DETAILS,
    params,
  });
};
export const documentDetails = (candidateId: number, documentId: number) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.KYC_DOCUMENT_DETAILS,
    params: {
      candidateId,
      documentId,
    },
  });
};
export const registeredEmp = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.LIST_OF_EMPLOYEES_STATUS,
    params,
  });
};

export const getExternalEmployeeList = (data: any, params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.GET_EXTERNAL_EMPLOYEES_LIST + params,
    data,
  });
};
export const registrationStatus = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.UPDATE_REGISTRATION_STATUS,
    data,
  });
};

export const employeeGridMapping = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.EMPLOYEE_ASSIGN_GRID,
    data,
  });
};

export const reportingManagerOfGrid = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.REPORTING_MANAGER_GRID,
    params,
  });
};

export const gridList = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.PINCODE_GRIDS,
    data,
  });
};

export const addComment = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.CREATE_NOTE,
    data,
  });
};
export const updateCandidateNameDetails = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.PUT,
    url: URL.UPDATE_CANDIDATE_NAME,
    data,
  });
};
export const removeAssignedGridDetails = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.REMOVE_ASSIGNED_GRID,
    data,
  });
};
export const LoginV = (data: any) => {
  return getApiClient(
    null,
    URL.BASE_URL_REST_FULL_ITUS
  )({
    method: METHOD.POST,
    url: URL.LOGIN_V,
    data,
  });
};

export const locationDetails = (data: any) => {
  return getApiClient(
    getAuthHeaders(getFromLocalStorage(STORAGE_KEY.ITUS)),
    URL.BASE_URL_REST_FULL_ITUS
  )({
    method: METHOD.POST,
    url: URL.PINCODE,
    data,
  });
};

export const updateDocumentStatus = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.PUT,
    url: URL.UPDATE_KYC_STATUS,
    data,
  });
};

// export const onPostSSOLogin = (data: any) => {
//   return getApiClient()({
//     method: METHOD.POST,
//     url: URL.POST_SSO_VALIDATION,
//     data,
//   });
// };

export const onPostSSOLogin = async (data: any) => {
  try {
    faro.api.pushLog(['📡 Calling onPostSSOLogin API']);

    const response = await getApiClient()({
      method: METHOD.POST,
      url: URL.POST_SSO_VALIDATION,
      data,
    });

    faro.api.pushLog(['✅ Successfully posted SSO login data']);
    return response;
  } catch (error) {
    faro.api.pushLog(['❌ Error posting SSO login data', error]);
    throw error;
  }
};

// export const logout = () => {
//   return getApiClient(getFullAuthHeaders())({
//     method: METHOD.POST,
//     url: URL.LOGOUT,
//   });
// };

export const logout = async () => {
  try {
    faro.api.pushLog(['📡 Calling logout API']);

    const response = await getApiClient(getFullAuthHeaders())({
      method: METHOD.POST,
      url: URL.LOGOUT,
    });

    faro.api.pushLog(['✅ Successfully logged out']);
    return response;
  } catch (error) {
    faro.api.pushLog(['❌ Error during logout', error]);
    throw error;
  }
};

export const getEmployeesLastLocationList = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.LAST_LOCATION_LIST,
    data,
  });
};

export const getEmployeeTrackingHistory = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.TRACKING_HISTORY,
    params,
  });
};

export const getTargetList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.TARGET_LIST,
    data,
  });
};

export const setTargetList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.SET_TARGET,
    data,
  });
};

export const getRemunerations = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.REMUNERATIONS_API_URL
  )({
    method: METHOD.POST,
    url: URL.REMUNERATION_LIST,
    data,
  });
};

export const getDetailedRemuneration = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.REMUNERATIONS_API_URL
  )({
    method: METHOD.GET,
    url: URL.DETAILED_REMUNERATION,
    params,
  });
};
export const getApproveReimbursementList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.APPROVE_REIMBURSMENT_LIST,
    data,
  });
};

export const approveRejectRemuneration = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.REMUNERATIONS_API_URL
  )({
    method: METHOD.POST,
    url: URL.APPROVE_REJECT_REMUNERATION,
    data,
  });
};

export const getTrackComplaintsList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TRACK_COMPLAINTS_API_URL
  )({
    method: METHOD.POST,
    url: URL.TRACK_COMPLAINTS_LIST,
    data,
  });
};
export const applyReimbursement = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.APPLY_REIMBURSMENT,
    data,
  });
};

export const getDetailedTrackComplaint = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TRACK_COMPLAINTS_API_URL
  )({
    method: METHOD.GET,
    url: URL.DETAILED_COMPLAINT,
    params,
  });
};
export const postReimbursementAttachments = (data: any, params: any) => {
  return getApiClient(
    getMultipartAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.REIMBURSMENT_ATTACHMENTS,
    data,
    params,
  });
};

export const fetchSeverityTypes = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.SEVERITY_TYPES,
  });
};

export const complaintAssign = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TRACK_COMPLAINTS_API_URL
  )({
    method: METHOD.POST,
    url: URL.COMPLAINT_ASSIGN,
    data,
  });
};
export const getReimbursementDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.GET,
    url: URL.REIMBURSEMENT_DETAILS,
    params,
  });
};

export const approveReimbursement = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.PUT,
    url: URL.APPROVE_REIMBURSMENT,
    data,
  });
};

export const getReimbursementLocationDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.GET,
    url: URL.REIMBURSEMENT_LOCATIONS,
    params,
  });
};

export const bannerGetAllList = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.BANNER_GET_ALL_LIST,
    params,
  });
};
export const bannerAddMedia = (data: any) => {
  return getApiClient(
    getMultipartAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.BANNER_ADD_NEW,
    data,
  });
};
export const bannerRemoveMedia = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.DELETE,
    url: URL.BANNER_REMOVE_MEDIA,
    params,
  });
};
export const bannerUpdateOrder = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.PUT,
    url: URL.BANNER_UPDATE_ORDER,
    params,
  });
};

export const knowledgeCenterAddMedia = (data: any) => {
  return getApiClient(
    getMultipartAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.KNOWLEDGE_CENTER_ADD_MEDIA,
    data,
  });
};

export const knowledgeCenterRemoveMedia = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.DELETE,
    url: URL.KNOWLEDGE_CENTRE_REMOVE_MEDIA,
    params,
  });
};

export const knowledgeCenterGetAllList = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.KNOWLEDGE_CENTER_ALL_LIST,
    params,
  });
};

export const knowledgeCenterGetAllTypes = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.KNOWLEDGE_CENTER_TYPES,
  });
};

export const galleryGetAllList = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.GALLERY_GET_ALL_LIST,
  });
};

export const galleryAddMedia = (data: any) => {
  return getApiClient(
    getMultipartAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.GALLERY_ADD_NEW,
    data,
  });
};
export const galleryRemoveMedia = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.DELETE,
    url: URL.GALLERY_REMOVE_MEDIA,
    params,
  });
};

export const addLatestUpdate = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.ADD_LATEST_UPDATE,
    data,
  });
};

export const removeLatestUpdate = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.DELETE,
    url: URL.REMOVE_LATEST_UPDATE,
    params,
  });
};

export const getAllLatestUpdates = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.ALL_LATEST_UPDATES,
    data,
  });
};

export const welcomeVideosAddMedia = (data: any) => {
  return getApiClient(
    getMultipartAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.WELCOME_VIDEOS_ADD_MEDIA,
    data,
  });
};

export const welcomeVideosRemoveMedia = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.DELETE,
    url: URL.WELCOME_VIDEOS_REMOVE_MEDIA,
    params,
  });
};

export const welcomeVideosGetAllList = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.WELCOME_VIDEOS_ALL_LIST,
  });
};

export const getPowerBiReportDetails = (params: any) => {
  return getApiClient(
    getPowerBIFullAuthHeaders(),
    URL.POWERBI_API
  )({
    method: METHOD.GET,
    url: `groups/${params.groupId}/reports/${params.reportId}`,
  });
};

export const getPowerBIAccess = (data: any) => {
  return getApiClient(
    getPowerBIFullAuthHeaders(),
    URL.POWERBI_API
  )({
    method: METHOD.POST,
    url: URL.POWERBI_ACCESS_TOKEN,
    data,
  });
};

export const getAllNotifications = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.GET_ALL_NOTIFICATIONS,
    data,
  });
};

export const markNotificationRead = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.POST,
    url: URL.MARK_READ_NOTIFICATIONS,
    data,
  });
};

export const getNotificationTypes = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.GET_NOTIFICATION_TYPES,
  });
};
export const getClaimsList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.POST,
    url: URL.GET_CLAIMS_LIST,
    data,
  });
};

export const getClaimsDetails = ({ claimID }: { claimID: string }) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.GET,
    url: `${URL.GET_CLAIMS_DETAILS}${claimID}`,
  });
};
